import { reconstituteBase64 } from 'utils/base64';
import { rootApiWithoutToken } from '..';
import { OTP, PaiementType } from './types';
export const PaiementApi = rootApiWithoutToken.injectEndpoints({
  endpoints: builder => ({
    getPaiement: builder.query<PaiementType, string>({
      query: (key: string) => ({
        url: `/wallet-web/operation-marchant-webs/${key}`,
      }),
      transformResponse: (response: PaiementType) => {
        response.logo = reconstituteBase64(response.logoContentType, response.logo);
        return response;
      },
    }),
    validatePaiement: builder.mutation<any, OTP>({
      query: (body: OTP) => ({
        url: `/wallet-web/operation-marchant-webs/${body.key}/${body.phoneNumber}`,
        method: 'GET',
      }),
    }),

    cancelPaiement: builder.mutation<any, string>({
      query: (key: string) => ({
        url: `/wallet-web/cancel-operation-marchant-webs/${key}`,
        method: 'GET',
      }),
    }),

    finishProcess: builder.mutation<any, OTP>({
      query: (body: OTP) => ({
        url: `/wallet-web/finish-operation-marchant-webs`,
        method: 'POST',
        body,
      }),
    }),
    redirectAfterSucceeded: builder.mutation<any, void>({
      query: () => ({
        url: `/wallet-web/redirect-marchant-web/sucess`,
        method: 'GET',
      }),
    }),
    redirectAfterCancelled: builder.mutation<any, void>({
      query: () => ({
        url: `/wallet-web/redirect-marchant-web/cancel`,
        method: 'GET',
      }),
    }),
    redirectAfterClosed: builder.mutation<any, void>({
      query: () => ({
        url: `/wallet-web/redirect-marchant-web/close`,
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
});

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
  useValidatePaiementMutation,
  useFinishProcessMutation,
  useCancelPaiementMutation,
  useGetPaiementQuery,
  useRedirectAfterCancelledMutation,
  useRedirectAfterClosedMutation,
  useRedirectAfterSucceededMutation,
} = PaiementApi;
